import { DText, Flex } from '../../../../../styles/CommonStyles'
import { formatName, getNames } from '../../../../../core/utils/common'
import Text from '../../../../../core/utils/Text'
import DateTime from '../../../../common/utils/DateTime'
import Operation from '../../../../common/utils/Operation'
import UserLink from '../../../../common/utils/UserLink'
import CoinRow from '../../../../common/common/CoinRow'
import ModalLayout from '../../../../layout/main/ModalLayout'
import useDuePayments from '../../../../../core/hooks/main/due-payments/useDuePayments'
import BasicModal from '../../../../modals/BasicModal'
import RTableLayout from '../../../../responsive/layout/RTableLayout'

const RVAsTable = ({ data }) => {
    const { data: vas } = data

    const {
        getVasOperation,
        modal,
        onModalClose,
        onOptionClicked,
        approveVaIsLoading,
        handleApprove
    } = useDuePayments()

    return (
        <RTableLayout data={data}>
            {vas?.data?.map((item, idx) => {
                const { FULLNAME } = getNames(
                    item.user?.firstName,
                    item.user?.lastName
                )

                const statusText = item.isOperational ? 'operational' : 'in_review'

                return (
                    <div
                        key={item._id}
                        style={{
                            border: '1px solid #eee',
                            borderRadius: 12,
                            padding: 12,
                            marginBottom: 12
                        }}
                    >
                        {/* HEADER */}
                        <Flex justify="space-between">
                            <UserLink
                                _id={item.userId}
                                name={formatName(FULLNAME)}
                            />

                            <Operation
                                hasWriteAccess
                                options={getVasOperation(idx)}
                                onOptionClicked={() => onOptionClicked(idx, item)}
                            />
                        </Flex>

                        {/* BODY */}
                        <Flex justify="space-between">
                            <DText fontSize={'s'} main>

                                <Text tid="account-id" />
                            </DText>
                            <DText fontSize={'s'} main>

                                <Text tid={item.accountId} />
                            </DText>
                        </Flex>

                        <Flex justify="space-between">
                            <DText fontSize={'s'} main>
                                <Text tid="currency" />
                            </DText>
                            <CoinRow
                                coin={{
                                    id: item.currency?.toLowerCase(),
                                    name: item.currency?.toLowerCase(),
                                    fa: item.currency?.toLowerCase()
                                }}
                            />
                        </Flex>

                        <Flex justify="space-between">
                            <DText fontSize={'s'} main>
                                <Text tid="status" />
                            </DText>
                            <DText fontSize={'s'} main>
                                <Text tid={statusText} />
                            </DText>
                        </Flex>

                        <Flex justify="space-between">
                            <DText fontSize={'s'} main>
                                <Text tid="date" />
                            </DText>
                            <DateTime dt={item.createdAt} />
                        </Flex>
                    </div>
                )
            })}

            <ModalLayout open={modal.open} width="520px" onClose={onModalClose}>
                <BasicModal
                    head="basic-vas"
                    desc="basic-vas-desc"
                    _id={modal.data?.id}
                    onSubmit={handleApprove}
                    onClose={onModalClose}
                    loading={approveVaIsLoading}
                />
            </ModalLayout>
        </RTableLayout>
    )
}

export default RVAsTable